import _implicitStylesheets from "./tile.css";
import _implicitScopedStylesheets from "./tile.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "card-content": true
  },
  key: 1
};
const stc1 = {
  attrs: {
    "name": "header"
  },
  key: 2
};
const stc2 = [];
const stc3 = {
  classMap: {
    "body": true
  },
  key: 3
};
const stc4 = {
  key: 4
};
const stc5 = {
  attrs: {
    "name": "footer"
  },
  key: 5
};
const stc6 = {
  attrs: {
    "name": "card-actions"
  },
  key: 6
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, s: api_slot, h: api_element} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.className),
    key: 0
  }, [api_element("div", stc0, [api_slot("header", stc1, stc2, $slotset), api_element("div", stc3, [api_slot("", stc4, stc2, $slotset)]), api_slot("footer", stc5, stc2, $slotset)]), api_slot("card-actions", stc6, stc2, $slotset)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["", "card-actions", "footer", "header"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-742ncugt5es";
tmpl.legacyStylesheetToken = "undefined-_tile";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
